export const setQueryKeys = {
  all: ['sets'] as const,
  one: (setId: string) => [...setQueryKeys.all, setId] as const,
} as const
